/**
 * @flow
 * @format
 */

import React from 'react';
import { pick } from 'lodash/fp';
import { Button, ButtonGroup } from 'reactstrap';
// import ContentEditable from 'react-simple-contenteditable';
import FaFile from 'react-icons/lib/fa/file';
import FaPencil from 'react-icons/lib/fa/pencil';
import FaCloud from 'react-icons/lib/fa/cloud';
import FaCopy from 'react-icons/lib/fa/copy';
import FaFolderOpen from 'react-icons/lib/fa/folder-open';
import FaFileText from 'react-icons/lib/fa/file-text';

import { deepDiffer, branch } from '~/utils';
// import classes from './LeftToolBar.scss';

type PropsType = {
  designName: string,
  designTitle: string,
  id: string | number,
  disableOpen: boolean,
  disableRedo: boolean,
  disableSave: boolean,
  disableUpdate: boolean,
  isSavedDesign: boolean,
  onNewDesign: Function,
  onOpen: Function,
  onRedo: Function,
  onSave: Function,
  onManage: Function,
  onDuplicateDesign: Function,
  onUpdateDesign: Function,
};

export class LeftToolBar extends React.Component<PropsType, *> {
  static defaultProps = {};

  props: PropsType;

  shouldComponentUpdate(nextProps: PropsType) {
    const subProps = pick([
      'designName',
      'disableOpen',
      'disableRedo',
      'disableSave',
    ]);
    return deepDiffer(subProps(this.props), subProps(nextProps));
  }

  render() {
    return (
      <ul className="nav">
        <li className="nav-item">
          <Button title="New Design" size="sm" onClick={this.props.onNewDesign}>
            <FaFile /> New
          </Button>
        </li>
        <li className="nav-item">
          <Button
            title="Manage Your Designs"
            size="sm"
            onClick={this.props.onOpen}
            disabled={this.props.disableOpen}
          >
            <FaFolderOpen /> My Designs
          </Button>
        </li>
        <li className="nav-item">
          {branch(
            this.props.isSavedDesign,
            <ButtonGroup>
              <Button
                size="sm"
                title="Save Design Changes"
                onClick={this.props.onUpdateDesign}
                disabled={this.props.disableUpdate}
              >
                <FaPencil /> Save
              </Button>
              <Button
                size="sm"
                title="Duplicate Current Design"
                onClick={() => this.props.onDuplicateDesign(this.props.id)}
                disabled={this.props.disableSave}
              >
                <FaCopy />
              </Button>
            </ButtonGroup>,
            <Button
              size="sm"
              title="Save Current Design"
              onClick={this.props.onSave}
              disabled={this.props.disableSave}
            >
              <FaCloud /> Save As
            </Button>,
          )}
        </li>
        <li className="nav-item align-self-center d-inline-flex">
          <FaFileText style={{ margin: '0 0.25rem 0.25rem 1rem' }} />
          {
            // <ContentEditable
            //   html={this.props.designTitle}
            //   tagName="div"
            //   onChange={e => console.log(e)}
            //   contentEditable="plaintext-only"
            // />
          }
          {this.props.designName || process.env.REACT_APP_INITIAL_DESIGN_NAME}
        </li>
      </ul>
    );
  }
}

export default LeftToolBar;



// WEBPACK FOOTER //
// ./src/components/LeftToolBar/LeftToolBar.js